import { render } from "./LocalizationMenu.vue?vue&type=template&id=a43acde2&scoped=true"
import script from "./LocalizationMenu.vue?vue&type=script&lang=js"
export * from "./LocalizationMenu.vue?vue&type=script&lang=js"

import "./LocalizationMenu.vue?vue&type=style&index=0&id=a43acde2&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a43acde2"]])

export default __exports__